// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");

function id(t) {
  return t.id;
}

function name(t) {
  return t.name;
}

function url(t) {
  return t.url;
}

function isGoogleReviewUrl(t) {
  return t.isGoogleReviewUrl;
}

function googlePlaceId(t) {
  return t.googlePlaceId;
}

function setName(t, name) {
  return {
          id: t.id,
          name: name,
          url: t.url,
          isGoogleReviewUrl: t.isGoogleReviewUrl,
          googlePlaceId: t.googlePlaceId
        };
}

function setUrl(t, url) {
  return {
          id: t.id,
          name: t.name,
          url: url,
          isGoogleReviewUrl: t.isGoogleReviewUrl,
          googlePlaceId: t.googlePlaceId
        };
}

function setIsGoogleReviewUrl(t, isGoogleReviewUrl) {
  return {
          id: t.id,
          name: t.name,
          url: t.url,
          isGoogleReviewUrl: isGoogleReviewUrl,
          googlePlaceId: t.googlePlaceId
        };
}

function setGooglePlaceId(t, googlePlaceId) {
  return {
          id: t.id,
          name: t.name,
          url: t.url,
          isGoogleReviewUrl: t.isGoogleReviewUrl,
          googlePlaceId: googlePlaceId
        };
}

function empty(param) {
  return {
          id: undefined,
          name: "",
          url: "",
          isGoogleReviewUrl: false,
          googlePlaceId: undefined
        };
}

function decode(json) {
  return {
          id: Json_decode.field("id", (function (param) {
                  return Json_decode.optional(Json_decode.$$int, param);
                }), json),
          name: Json_decode.field("name", Json_decode.string, json),
          url: Json_decode.field("url", Json_decode.string, json),
          isGoogleReviewUrl: Json_decode.field("is_google_review_url", (function (param) {
                  return Json_decode.withDefault(false, Json_decode.bool, param);
                }), json),
          googlePlaceId: Json_decode.field("google_place_id", (function (param) {
                  return Json_decode.optional(Json_decode.string, param);
                }), json)
        };
}

function encode(t) {
  return Json_encode.object_({
              hd: [
                "id",
                Json_encode.nullable((function (prim) {
                        return prim;
                      }), t.id)
              ],
              tl: {
                hd: [
                  "name",
                  t.name
                ],
                tl: {
                  hd: [
                    "url",
                    t.url
                  ],
                  tl: {
                    hd: [
                      "is_google_review_url",
                      t.isGoogleReviewUrl
                    ],
                    tl: {
                      hd: [
                        "google_place_id",
                        Json_encode.nullable((function (prim) {
                                return prim;
                              }), t.googlePlaceId)
                      ],
                      tl: /* [] */0
                    }
                  }
                }
              }
            });
}

exports.id = id;
exports.name = name;
exports.url = url;
exports.isGoogleReviewUrl = isGoogleReviewUrl;
exports.googlePlaceId = googlePlaceId;
exports.setName = setName;
exports.setUrl = setUrl;
exports.setIsGoogleReviewUrl = setIsGoogleReviewUrl;
exports.setGooglePlaceId = setGooglePlaceId;
exports.empty = empty;
exports.decode = decode;
exports.encode = encode;
/* No side effect */
